// 1. IMPORTS
import Request from "./request";
import { removeEmptyValues } from "helper/UtilsFunctionsObject";

// 4. API CALLS
class PaymentMethodServiceAPI {
  static async getListPaymentMethod(data) {
    const response = await Request.send({
      method: "POST",
      path: "/PaymentMethod/advanceUser/getList",
      data: removeEmptyValues(data),
    });
    if (response?.statusCode !== 200) {
      throw new Error(response?.message || "Không lấy được thông tin thanh toán");
    }
    return response.data;
  }

  static async createPaymentMethod(data) {
    const response = await Request.send({
      method: "POST",
      path: "/PaymentMethod/advanceUser/create",
      data: removeEmptyValues(data),
    });
    if (response?.statusCode !== 200) {
      throw new Error(response?.message || "Không tạo được phương thức thanh toán");
    }
    return response.data;
  }

  static async updatePaymentMethod({ id, data }) {
    const response = await Request.send({
      method: "POST",
      path: "/PaymentMethod/advanceUser/updateById",
      data: { id, data: removeEmptyValues(data) },
    });
    if (response?.statusCode !== 200) {
      throw new Error(response?.message || "Không cập nhật được phương thức thanh toán");
    }
    return response.data;
  }
}

// 9. EXPORTS
export default PaymentMethodServiceAPI;